import { onGetSupport, onSetSupportReply } from 'data/support/support.service';
import { useDispatch } from 'react-redux';
import supportSlice from 'redux/slice/support.slice';
import { SupportResponseModel } from '../../../data/support/support.model';

// eslint-disable-next-line import/prefer-default-export
export const useSupport = () => {
  const dispatch = useDispatch();

  const fetchSupport = async (): Promise<void> => {
    dispatch(supportSlice.actions.setLoading());
    try {
      const res = await onGetSupport();
      console.log(res);
      const data: { replied: SupportResponseModel[]; notReplied: SupportResponseModel[] } = {
        replied: [],
        notReplied: [],
      };
      res.forEach((item) => {
        // eslint-disable-next-line no-underscore-dangle
        if (item.__replies__.length === 0) {
          data.notReplied.push(item);
        } else {
          data.replied.push(item);
        }
      });
      dispatch(supportSlice.actions.setData(data));
    } catch (err) {
      dispatch(supportSlice.actions.setError(err));
    }
  };

  const postReply = async (id: string, description: string): Promise<void> => {
    dispatch(supportSlice.actions.setLoading());
    try {
      await onSetSupportReply({ id, description });
    } catch (error) {
      dispatch(supportSlice.actions.setError(error));
    }
  };

  return { fetchSupport, postReply };
};
